import * as yup from "yup";

import { fetchData } from "@utils/api";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { TranslationLangDto, translationLangSchema } from "./common";

export const fetchClinicActivities = async (
  params?: URLSearchParams,
): Promise<ApiResponse<ClinicActivitiesDto[]>> => {
  const response = await fetchData(
    "/dietitian/clinic/activities",
    APIMethods.GET,
    undefined,
    params,
  );

  return await fetchClinicActivitiesSchema.validate(response);
};

interface EventDto {
  id: number;
  name: string;
  translations: TranslationLangDto[];
}
export interface ClinicActivitiesDto {
  id: number;
  firstName: string;
  lastName: string;
  date: string;
  createdBy: string;
  event: EventDto;
}

const eventSchema = yup.object().shape({
  id: yup.number().required(),
  name: yup.string().required(),
  translations: yup.array().of(translationLangSchema).required(),
});

const clinicActivitySchema = yup.object().shape({
  id: yup.number().required(),
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  date: yup.string().required(),
  createdBy: yup.string().required(),
  event: eventSchema.required(),
});

const fetchClinicActivitiesSchema = yup.object().shape({
  data: yup.array().of(clinicActivitySchema).required(),
});
